import * as React from 'react';
import {translate} from 'react-i18next';
import {connect, Dispatch} from "react-redux";
import {Location} from "history";
import {MenuDto, MaintenanceListDto, VersionInfoDto} from "../services/Client";
import GeneralActions from "../redux/actions/GeneralActions";
import {compose} from 'redux';
import HATEOASClient from 'src/services/HATEOASClient';
import {IReduxState} from '../redux/IReduxState';
import {Checkbox, CheckboxProps} from 'semantic-ui-react';
import {selectClient} from '../redux/selectors';
import {selectMaintenanceStatus, selectVersionInfo} from 'src/redux/selectors/generalSelectors';

// Set of possible properties for this View
interface IMapStateToProps {
    client: HATEOASClient;
    maintenanceStatus?: MaintenanceListDto;
    versionInfo?: VersionInfoDto;
}

interface IMapDispatchToProps {
    ReceiveMaintenanceStatus: (maintenanceStatus: MaintenanceListDto) => void;
}

interface IMaintenanceStatusParams extends IMapStateToProps, IMapDispatchToProps {
    t: reactI18Next.TranslationFunction;
    location?: Location;
    history: any;
}

interface IMaintenanceStatusState {
    username: string;
    password: string;
    isLoading: boolean;
    code: string;
}

export class MaintenanceStatus extends React.Component<IMaintenanceStatusParams, IMaintenanceStatusState> {
    constructor(props: IMaintenanceStatusParams) {
        super(props);

        this.state = {
            username: "",
            password: "",
            code: "",
            isLoading: true,
        };

    }
    componentDidMount() {
        if (this.props.maintenanceStatus && !this.props.maintenanceStatus.elements) {
            localStorage.clear();
            sessionStorage.clear();
            this.props.history.push('/login');
        }
    }
    getVersionLabel = (): string => {
        if (!this.props.versionInfo) {
            return "Version information unavailable";
        }

        const versions = (this.props.versionInfo as any).componentVersions || this.props.versionInfo;
        const entries = Object.keys(versions || {}).filter((key: string) => versions[key] !== undefined && versions[key] !== null && versions[key] !== "");

        if (entries.length === 0) {
            return "Version information unavailable";
        }

        return entries.map((key: string) => `${key}: ${versions[key]}`).join(' / ');
    }
    updateMaintenanceStatus = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
        event.preventDefault();
        if (this.props.maintenanceStatus && this.props.maintenanceStatus.links && this.props.maintenanceStatus.elements) {
            const maintenanceStatus = this.props.maintenanceStatus.elements[0];
            const payload = {
                title: maintenanceStatus.title,
                content: maintenanceStatus.content,
                objectId: maintenanceStatus.objectId,
                versionId: maintenanceStatus.versionId,
                active: !maintenanceStatus.active
            };
            this.props.client.PATCH_maintenanceStatus(this.props.maintenanceStatus as MenuDto).execute(payload).then(() => {
                localStorage.clear();
                sessionStorage.clear();
                window.location.reload();
            });
        }
    }

    render() {
        const maintenanceStatus = this.props.maintenanceStatus && this.props.maintenanceStatus.elements ? this.props.maintenanceStatus.elements[0] : undefined;
        const isMaintenanceActive = !!(maintenanceStatus && maintenanceStatus.active);
        const versionLabel = this.getVersionLabel();

        return (
            <div className="maintenance-view-container">
                <div className='maintenance_container_right'>
                    {this.props.maintenanceStatus
                        && this.props.maintenanceStatus
                        && this.props.maintenanceStatus.links
                        && <Checkbox
                            toggle={true}
                            checked={isMaintenanceActive}
                            onChange={(event: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => this.updateMaintenanceStatus(event)}
                        />}
                </div>
                <div className='maintenance_container'>
                    <div>
                        <div className="logo-image">
                            <img src="./images/Logos/ProMT_Black_70.png" className="ui centered image" />
                        </div>
                        <div className='maintenance_text'>
                            {maintenanceStatus && <p>{maintenanceStatus.content}</p>}
                            <p>Version: {versionLabel}</p>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state),
    maintenanceStatus: selectMaintenanceStatus(state),
    versionInfo: selectVersionInfo(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    ReceiveMaintenanceStatus: (maintenanceStatus: MaintenanceListDto) => dispatch(GeneralActions.ReceiveMaintenanceStatus(maintenanceStatus))
});

// connect export with translate for translation and connect for state propagation
export default compose<React.ComponentType<any>>(
    translate(['LOGIN', 'ERRORS']),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(MaintenanceStatus);



// WEBPACK FOOTER //
// ./src/views/MaintenanceStatus.tsx